import { NgModule } from "@angular/core";

import { SearchModule, IconModule } from "@bitwarden/components";
import { VaultFilterServiceAbstraction } from "@bitwarden/vault";

import { VaultFilterSharedModule } from "../../individual-vault/vault-filter/shared/vault-filter-shared.module";

import { OrganizationOptionsComponent } from "./components/organization-options.component";
import { VaultFilterComponent } from "./components/vault-filter.component";
import { WebIndividualVaultFilterService } from "./web-individual-vault-filter.service";

@NgModule({
  imports: [VaultFilterSharedModule, SearchModule, IconModule, OrganizationOptionsComponent],
  declarations: [VaultFilterComponent],
  exports: [VaultFilterComponent],
  providers: [
    {
      // Includes PAM-gated ("partial") ciphers in the folder tree, to match the web vault list.
      provide: VaultFilterServiceAbstraction,
      useClass: WebIndividualVaultFilterService,
    },
  ],
})
export class VaultFilterModule {}
